
export default {
  'filters.title': 'Filtres',
  'filters.browse': 'Filtrer',
  'filters.saved': 'Filtres sauvegardés',
  'filters.basic': 'Base',
  'filters.attributes': 'Attributs',
  'filters.availability': 'Disponibilité',
  'filters.location': 'Lieu',
  'filters.age_range': 'Âge',
  'filters.gender': 'Genre',
  'filters.services': 'Services',
  'filters.languages': 'Langues',
  'filters.verification': 'Statut de vérification',
  'filters.status': 'Statut',
  'filters.price_range': 'Fourchette de prix',
  'filters.all_locations': 'Tous les lieux',
  'filters.search_location': 'Rechercher un lieu...',
  'filters.no_location_found': 'Aucun lieu trouvé',
  'filters.reset': 'Réinitialiser',
  'filters.apply': 'Appliquer',
  'filters.save': 'Sauvegarder',
  'filters.filter_name': 'Nom du filtre',
  'filters.save_current_filter': 'Sauvegarder le filtre actuel',
  'filters.delete': 'Supprimer',
  'filters.no_saved_filters': 'Pas encore de filtres sauvegardés',
  'filters.select_filter': 'Sélectionner un filtre',
  'filters.applied_filters': 'Filtres appliqués:',
  
  // Sort filter options
  'filters.sort_by': 'Trier par',
  'filters.sort_options.newest': 'Plus récent',
  'filters.sort_options.popularity': 'Plus populaire',
  'filters.sort_options.relevance': 'Plus pertinent',
  'filters.show_with_reviews': 'Montrer les profils avec commentaires',
  
  // Advanced filters
  'filters.physical_attributes': 'Attributs physiques',
  'filters.height': 'Taille',
  'filters.weight': 'Poids',
  'filters.hair_color': 'Couleur de cheveux',
  'filters.eye_color': 'Couleur des yeux',
  'filters.body_type': 'Type de corps',
  'filters.habits': 'Habitudes',
  'filters.smoking': 'Fumeur',
  'filters.drinking': 'Alcool',
  'filters.available_days': 'Jours disponibles',
  'filters.available_hours': 'Heures disponibles',
  'filters.from': 'De',
  'filters.to': 'À',
  'filters.select_hour': 'Sélectionner heure',
  'filters.select_all': 'Tout sélectionner',
  'filters.clear': 'Effacer',
  
  'filters.options.yes': 'Oui',
  'filters.options.no': 'Non',
  'filters.options.occasionally': 'Occasionnellement',
  
  'filters.hair_colors.blonde': 'Blond',
  'filters.hair_colors.brown': 'Brun',
  'filters.hair_colors.black': 'Noir',
  'filters.hair_colors.red': 'Roux',
  'filters.hair_colors.other': 'Autre',
  
  'filters.eye_colors.blue': 'Bleu',
  'filters.eye_colors.green': 'Vert',
  'filters.eye_colors.brown': 'Brun',
  'filters.eye_colors.hazel': 'Noisette',
  'filters.eye_colors.other': 'Autre',
  
  'filters.body_types.slim': 'Mince',
  'filters.body_types.athletic': 'Athlétique',
  'filters.body_types.average': 'Moyen',
  'filters.body_types.curvy': 'Pulpeuse',
  'filters.body_types.plus_size': 'Fort(e)',
  
  'filters.days.monday': 'Lundi',
  'filters.days.tuesday': 'Mardi',
  'filters.days.wednesday': 'Mercredi',
  'filters.days.thursday': 'Jeudi',
  'filters.days.friday': 'Vendredi',
  'filters.days.saturday': 'Samedi',
  'filters.days.sunday': 'Dimanche',
};
